import React, { useMemo } from 'react';
import QUICK_ACTION_ICONS from '../../QuickActionIcons';

interface OptionIconProps {
  icon?: string;
}

const OptionIcon = function ({ icon = '' }: OptionIconProps) {
  const Icon = useMemo(() => (
    QUICK_ACTION_ICONS.find(({ value }) => value === icon)?.icon
  ), [icon]);

  return Icon ? <Icon /> : null;
};

export default OptionIcon;
